import React from 'react';
import styled from 'styled-components';

type Props = {
  show: boolean;
};

export class LoadingIndicator extends React.PureComponent<Props> {
  render() {
    const { show } = this.props;

    return <Container className={`LoadingIndicator ${show ? 'show' : ''}`}>
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    </Container>;
  }
}

const Container = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: white;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.5s, opacity 0.5s;

  &.show {
    visibility: visible;
    opacity: 0.9;
  }
`;

const SpinnerContainer = styled.div`
  display: block;
  height: 5em; /* prevents shaking during height animation */
  width: 5em;
`;

const Spinner = styled.div`
  color: black;
  margin: 0;
  position: relative;
  font-size: 11px;
  transform: translateZ(0);
  animation-delay: -0.16s !important;
  height: 5em;

  &,
  &:before,
  &:after {
    background: black;
    animation: load1 1s infinite ease-in-out;
    width: 1em;
    height: 4em;
  }

  &:before,
  &:after {
    position: absolute;
    top: 0;
    content: '';
  }

  &:before {
    left: -1.5em;
    animation-delay: -0.32s;
  }

  &:after {
    left: 1.5em;
    animation-delay: 0;
  }

  @keyframes load1 {
    0%,
    80%,
    100% {
      box-shadow: 0 0;
      height: 4em;
    }
    40% {
      box-shadow: 0 -2em;
      height: 5em;
    }
  }
`;